<template lang="pug">
    v-app
        v-toolbar(:color="colorPayer" dark style="z-index: 12;")
            actions-menu
            v-spacer
            SessionBox(:infoSession="infoLog")
                v-btn(
                    icon
                    @click="handleToggle"
                    large
                    )
                    v-icon(
                        :class="htmlPrint ? ['orange--text'] : []"
                        size="30"
                        )
                        | {{htmlPrint ? 'toggle_on' : 'toggle_off'}}
                span Impresión HTML
        snackbar-modal
        AuthModal(
            available
            style="position: absolute; left: -2000px; top: 0px;"
            @check-key="checkAuth()"
            ref="authModal"
            activatorId="print-auth"
            )
        //- NO BORRAR (es código para hacer pruebas de snackbar)
        //v-flex(md3)
            v-btn(color="green darken-1" @click="testSnackbar")
            v-btn(color="red darken-1" @click="testSnackbar2")
        router-view
</template>

<script>
import ActionsMenu from '@/components/ActionsMenu/ActionsMenu'
import SessionBox from '@/components/SessionBox/SessionBox.vue'
import SnackbarModal from '@/components/SnackbarModal/SnackbarModal'
// import KeyBinds from '@/mixins/KeyBinds'
import { mapActions, mapState } from 'vuex'
import { getAndSaveLoginToken } from '@/services/auth/AuthService'
import PosCashDesk from './models/POS/PosCashDesk'
import { _setPanicButton, _removePanicButton } from './panicButton'
import AuthModal from '@/components/SupervisorUniqueKey/Modal'
export default {
    name: 'CashDesk-root',
    props: {},

    data: function() {
        return {
            infoLog: {
                name: '',
                number: '',
                userName: '',
            },
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            payer: 'payer',
        }),
        ...mapState('AuthModule', {
            cash_desk_id: 'cash_desk_id',
            cash_desk_token: 'cash_desk_token',
            user: 'user',
        }),
        ...mapState('SessionModule', ['htmlPrint']),
        /*
        _htmlPrint: {
            get() {
                return this.htmlPrint
            },
            set(v) {
                this.setHtmlPrint(v)
            },
        },
        */
        colorPayer: function() {
            if (this.payer == 'SE') {
                return this.colors.saleEmployee
            } else {
                return this.colors.primary
            }
        },
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            setAlignTop: 'setAlignTop',
        }),
        ...mapActions('AuthModule', {
            fetchCashDeskID: 'fetchCashDeskID',
        }),
        ...mapActions('SessionModule', {
            initCompanyData: 'initCompanyData',
            setHtmlPrint: 'setHtmlPrint',
            fetchCustomerCreditOptions: 'fetchCustomerCreditOptions',
            fetchPchPaymentConditions: 'fetchPchPaymentConditions',
        }),
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            setPermission: 'setPermission',
        }),
        testSnackbar() {
            let payload = {
                typeMessage: 'success', // values accepted: 'success', 'error', 'warning', 'info'. Set to another value for a normal light-black background snackbar.
                message: {
                    title: 'titleeeeeee', // set to null for a small snackbar.
                    body: 'body message',
                },
                timeout: 0, // Value in milliseconds. Set to 0 for a snackbar that will never close automatically.
                showProgress: true, // set to true to show a progress/loading animation on the right of the snackbar.
                showCloseBtn: true, // set to false to hide the close button
                closeBtnMessage: 'cerrar', // message showed in close button
            }
            this.setAlignTop(false)
            this.initSnackbar(payload)
        },

        handleToggle(e) {
            e.preventDefault()
            e.stopPropagation()
            this.$refs.authModal.$el.querySelector('#print-auth').click()
        },

        testSnackbar2() {
            let payload = {
                typeMessage: '', // values accepted: 'success', 'error', 'warning', 'info'. Set to another value for a normal light-black background snackbar.
                message: {
                    title: null, // set to null for a small snackbar.
                    body: 'body bodu body ',
                },
                timeout: 0, // Value in milliseconds. Set to 0 for a snackbar that will never close automatically.
                showProgress: true, // set to true to show a progress/loading animation on the right of the snackbar.
                showCloseBtn: true, // set to false to hide the close button
                closeBtnMessage: 'cerrar', // message showed in close button
            }
            this.setAlignTop(true)
            this.initSnackbar(payload)
        },
        getInfoBranchOffice() {
            if ([null, undefined].includes(this.cash_desk_id))
                return setTimeout(() => this.getInfoBranchOffice(), 200)
            PosCashDesk.include('g_branch_office')
                .find(this.cash_desk_id)
                .then(r => {
                    let userName = this.getUserName()
                    this.infoLog = {
                        ...r,
                        name: r.g_branch_office.name,
                        userName: userName,
                    }
                    this.getUserName()
                })
                .catch(e => {
                    console.log(e)
                })
        },
        getUserName() {
            let rep = JSON.parse(localStorage.getItem('user'))
            return rep.hr_employee.names + ' ' + rep.hr_employee.last_name1
        },

        checkAuth() {
            this.setPermission(
                this.mixAuthCodePermissions.CREATE_AUTH_POS_DAILY_SALE_REPORT
            )
            this.authorize()
                .then(r =>
                    r.status && [200, 201, 'success'].includes(r.status)
                        ? this.setHtmlPrint(!this.htmlPrint)
                        : this.showErrorSnack('Código Incorrecto')
                )
                .catch(e =>
                    this.showErrorSnack(
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                            ? e.response.data.error
                            : e || 'Ha ocurrido un error'
                    )
                )
        },
        showErrorSnack(text) {
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
    },

    components: { ActionsMenu, SnackbarModal, SessionBox, AuthModal },
    mixins: [],
    filters: {},

    // Lifecycle Methods
    //
    beforeCreate: function() {
        getAndSaveLoginToken()
    },
    created: async function() {
        let url = new URLSearchParams(window.location.search)
        if (!this.cash_desk_token) return
        if (!this.cash_desk_id) {
            await this.fetchCashDeskID()
        }
        this.initCompanyData()
        this.fetchCustomerCreditOptions()
        this.fetchPchPaymentConditions()
    },
    // beforeMount: function(){...},
    mounted: function() {
        this.getInfoBranchOffice()
        _setPanicButton()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    beforeDestroy: function() {
        _removePanicButton()
    },
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
